<div
  class="multi-select-dropdown position-relative"
  [class.ds-dropup]="dropUp || computedDropUp"
  [class.ds-inline]="inlineList"
  style="min-width: 100px; max-width: 100%; width: 100%"
>
  <!-- Input container style="min-height: 38px; overflow: hidden;"-->
  <div
    *ngIf="!inlineList"
    class="input-container d-flex flex-wrap align-items-center border rounded p-2"
    [ngClass]="[
      isDisabled || isFieldsetDisabled ? 'bg-gray-disabled' : 'bg-white-enabled',
      design
    ]"
    (click)="isDisabled || this.isFieldsetDisabled ? null : showDropdown()"
  >
    <!-- Placeholder -->
    <span *ngIf="!hasSelectedItem()" class="ds-placeholder">
      {{ design === 'chips' && chipsEmptyLabel ? chipsEmptyLabel : placeHolder }}
    </span>

    <!-- Chips des éléments sélectionnés -->
    <ng-container *ngFor="let item of items; trackBy: trackByLabel">
      <span *ngIf="item.selected" class="ds-chip">
        <i
          *ngIf="item.iconClass"
          class="ds-option-icon"
          [class]="item.iconClass + ' ds-option-icon'"
          [style.color]="item.iconColor"
          aria-hidden="true"
        ></i>
        <span class="ds-chip__label">
          {{ translateLabels ? (item.label | translate) : item.label }}
        </span>
        <button
          *ngIf="!isDisabled && !isFieldsetDisabled && canRemoveChip()"
          type="button"
          class="ds-chip__remove"
          aria-label="Retirer"
          (click)="removeItem(item, $event)"
        >
          <i class="fas fa-times"></i>
        </button>
      </span>
    </ng-container>
  </div>

  <!-- Dropdown liste - MultiSelect -->
  <div
    *ngIf="(isDropdownVisible || inlineList) && isMultiSelect"
    class="dropdown-menu show w-100 shadow-sm border rounded"
    [ngStyle]="{
      'max-height.px': computedMaxHeight,
      'overflow-y': 'auto',
      display: 'flex',
      'flex-direction': 'column',
      'background-color': 'white',
      'z-index': 1050
    }"
  >
    <!-- Section fixe -->
    <div class="sticky-top p-2 mb-2 border-bottom">
      <!-- Champ de recherche -->
      <input
        #searchInput
        [value]="searchValue"
        type="text"
        class="form-control"
        style="margin-bottom: 10px"
        [disabled]="isDisabled || isFieldsetDisabled"
        (input)="filterItems($event)"
        [placeholder]="'Rechercher'"
      />

      <!-- Bouton de validation -->
      <div class="d-flex justify-content-end align-items-center" *ngIf="!hideValidateButton">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          style="margin-right: 0"
          [disabled]="isDisabled || isFieldsetDisabled"
          (click)="confirmSelection()"
        >
          {{ validateButtonTitle() }}
        </button>
      </div>
    </div>

    <!-- Liste des options (scrollable) -->
    <div style="overflow-y: auto; flex-grow: 1">
      <ng-container *ngFor="let item of filteredItems; trackBy: trackByLabel">
        <div
          class="dropdown-item d-flex align-items-center justify-content-between"
          [class.pe-none]="isDisabled || isFieldsetDisabled"
          [class.ds-option-disabled]="item.disabled"
          (click)="toggleMultiItem(item, $event)"
        >
          <div
            class="d-flex align-items-center w-100"
            style="
              max-width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <input
              type="checkbox"
              class="form-check-input me-2"
              [checked]="item.selected"
              [disabled]="item.disabled"
            />
            <i
              *ngIf="item.iconClass"
              class="ds-option-icon me-2"
              [class]="item.iconClass + ' ds-option-icon me-2'"
              [style.color]="item.iconColor"
              aria-hidden="true"
            ></i>
            <span class="flex-grow-1 text-truncate">
              {{ translateLabels ? (item.label | translate) : item.label }}
            </span>
            <i *ngIf="item.disabled" class="fas fa-lock ms-2 ds-option-lock" aria-hidden="true"></i>
          </div>
        </div>
      </ng-container>

      <!-- En cours de chargement -->
      <ng-container *ngIf="isLoading && filteredItems.length === 0">
        <div
          class="dropdown-item text-truncate"
          style="
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          Chargement...
        </div>
      </ng-container>
      <!-- Message en cas de liste vide -->
      <ng-container *ngIf="!isLoading && filteredItems.length === 0">
        <div
          class="dropdown-item text-truncate"
          style="
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          Aucun résultat trouvé
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Dropdown liste - SingleSelect -->
  <div
    *ngIf="(isDropdownVisible || inlineList) && !isMultiSelect"
    class="dropdown-menu show w-100 shadow-sm border rounded"
    [ngStyle]="{
      'z-index': 1050,
      'max-height.px': computedMaxHeight,
      'overflow-y': 'auto',
      display: 'flex',
      'flex-direction': 'column',
      'background-color': 'white'
    }"
  >
    <!-- Section fixe -->
    <div class="sticky-top p-2 mb-2 border-bottom">
      <!-- Champ de recherche -->
      <input
        #searchInput
        [value]="searchValue"
        type="text"
        class="form-control mb-2"
        [disabled]="isDisabled || isFieldsetDisabled"
        (input)="filterItems($event)"
        [placeholder]="'Rechercher'"
      />
    </div>

    <!-- Liste des options (scrollable) -->
    <div style="overflow-y: auto; flex-grow: 1">
      <ng-container *ngFor="let item of filteredItems; trackBy: trackByLabel">
        <div
          class="dropdown-item text-truncate"
          [class.pe-none]="isDisabled || isFieldsetDisabled"
          [class.ds-option-disabled]="item.disabled"
          (click)="toggleSingleItem(item, $event)"
          style="
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <i
            *ngIf="item.iconClass"
            class="ds-option-icon me-2"
            [class]="item.iconClass + ' ds-option-icon me-2'"
            [style.color]="item.iconColor"
            aria-hidden="true"
          ></i>
          <span>{{ translateLabels ? (item.label | translate) : item.label }}</span>
          <i *ngIf="item.disabled" class="fas fa-lock ms-2 ds-option-lock" aria-hidden="true"></i>
        </div>
      </ng-container>

      <!-- En cours de chargement -->
      <ng-container *ngIf="isLoading && filteredItems.length === 0">
        <div
          class="dropdown-item text-truncate"
          style="
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          Chargement...
        </div>
      </ng-container>

      <!-- Message en cas de liste vide -->
      <ng-container *ngIf="!isLoading && filteredItems.length === 0">
        <div
          class="dropdown-item text-truncate"
          style="
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          Aucun résultat trouvé
        </div>
      </ng-container>
    </div>
  </div>
</div>
